import './Business.css';
import '../animations.css';
import { useEffect, useState, useRef } from 'react';

function Business() {
  const [imageLoaded, setImageLoaded] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const img = new Image();
    img.src = 'https://cd-1302933783.cos.ap-guangzhou.myqcloud.com/XenoHomepage/yoga-bg.png';
    img.onload = () => setImageLoaded(true);
  }, []);

  // 滚动监听，当元素接近显示位置时触发
  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;
      const rect = containerRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      // 当元素的顶部进入视口底部80%位置时触发
      if (rect.top < viewportHeight * 0.8 && rect.bottom > 0) {
        containerRef.current.classList.add('visible');
      }
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="Business">
        <div className={`Bussiness-yoga background ${imageLoaded ? 'loaded' : ''}`}>  
          <div ref={containerRef} className='Bussiness-yoga-container animate-on-scroll-below'>
            <h1 className='Bussiness-yoga-title'>
              Yoga Studio
            </h1>
            <div className='Bussiness-yoga-description'>
              A place where you can relax and meditate.
            </div>
          </div>
        </div>
    </div>
  );
}

export default Business;
